import * as moment from 'moment';

import { Expense } from '@sd-portal/post-flight/feature-expense';
import { Squawk, SquawksExternalSyncResult } from '@sd-portal/post-flight/feature-squawks';
import { Airport } from '@sd-portal/shared/airport';
import { AircraftComponentsModel } from '@sd-portal/post-flight/models-aircraft-component';

import { AutomatedFlightData } from './automated-flight-data.model';
import { FlightCrewMember } from './flight-crew-member.model';
import { FlightPassenger } from './flight-passenger.model';
import { FluidComponent } from './fluid-component.model';
import { PartOperation } from './enums/part-operation.enum';
import { FlightLogSign } from '../../../feature-post-flight/src/lib/_models/leg-flightlogsign.model';
import { ESignResponse } from '@sd-portal/shared/util';
import { FlightBusinessPerson } from '@sd-portal/shared/models';

export class Leg {
  postedFlightId: number = 0;
  legNumber?: number;
  logNumber?: string;
  departureAirport?: Airport;
  arrivalAirport?: Airport;
  departureFboId?: number;
  arrivalFboId?: number;
  departureDateTime?: moment.Moment;
  arrivalDateTime?: moment.Moment;
  partOperation: PartOperation | null = null;
  customTripId?: string;

  hobbsOutTime?: moment.Moment | null;
  hobbsInTime?: moment.Moment | null;
  hobbsStartMinutes?: number | null;
  hobbsEndMinutes?: number | null;
  hobbsDurationMinutes?: number | null;
  previousHobbsEndMinutes: number | null;

  outTime?: moment.Moment;
  offTime?: moment.Moment;
  onTime?: moment.Moment;
  inTime?: moment.Moment;
  verifiedDate?: moment.Moment;
  verifiedByUserName?: string;
  // flightTime?: string;
  // blockTime?: string;
  distance?: number;
  delayTypeId?: number;
  delayDuration?: number;
  goArounds?: number;
  rejectedTakeoffs?: number = 0;
  newLandings: number = 1;
  automatedData: AutomatedFlightData | null;

  fuelOut?: number;
  fuelOff?: number;
  fuelOn?: number;
  fuelIn?: number;
  fuelBurn?: number;

  quantityTypeId?: number;
  upliftQuantityTypeId?: number;
  plannedUp?: number;
  actualUp?: number;
  notes?: string;
  crewNotes?: string;
  paxNotes?: string;
  departureFboNotes?: string;
  arrivalFboNotes?: string;
  previousPostedFlightId: number | null;
  nextPostedFlightId: number | null;
  previousScheduledFlightId: number | null;
  nextScheduledFlightId: number | null;
  totalLegCount: number;

  // flags
  canSelectPartOperation = false;
  isEVSEquipped: boolean = false;
  isParentTripVerified: boolean = false;
  isTechStop = false;
  isVerified: boolean = false;
  postedFlightStatusTypeId: number;
  postedFlightStatusTypeName: string;
  showHobbs: boolean = false;
  // FKs
  aircraftId: number = 0;
  tripId?: number;
  businessCategoryId?: number;
  departmentId?: number;
  scheduledFlightId?: number;
  scheduledTripId?: number;
  externalFlightId?: string;
  // Hydraulic Fluids & De-icing
  hydraulicUsage: number | null;
  hydraulicFluidUnitTypeId: number | null;
  // deice
  deIceEndDateTime?: moment.Moment;
  deIceStartDateTime?: moment.Moment;
  deIceMixRatioTypeId?: number | null;
  deIceTypeId?: number | null;
  // collections
  flightPassengers?: FlightPassenger[];
  flightCrewMembers?: FlightCrewMember[];
  fluids?: FluidComponent[];
  expenses?: Expense[];
  squawks?: Squawk[];
  postedFlightComponents?: AircraftComponentsModel[]; // eslint-disable-line @typescript-eslint/no-explicit-any
  // esignature
  flightLogSignId?: number | null;
  flightLogSign: FlightLogSign | null;
  // index signature
  legPurposeNotes: string;
  statuteMiles: number;
  directNauticalMiles: number;
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any

  squawksExternalSyncResult: SquawksExternalSyncResult | null;
  flightBusinessPersons?: FlightBusinessPerson[];
  isHideInPostflight: boolean;
}

export class FlightLogVoidCorrect {
  pinNumber: number;
  legDetails: Leg;
}

export class VoidCorrectFlightLogResponse {
  response: ESignResponse;
  leg: Leg;
}
